<template>
  <v-app>
    <h-cookie-warn />
    <v-main class="accent">
      <v-container fluid>
        <v-row v-if="$page.props.brand === 'HANDY'" justify="end" align="center" class="pt-1 pr-2">
          <h-locale />
        </v-row>
        <v-row justify="center" :class="$page.props.brand === 'SBL' ? 'pt-5 pb-10' : 'pt-6 pb-12'">
          <v-slide-y-transition>
            <h-logo v-show="showLogo" width="280" height="34" />
          </v-slide-y-transition>
        </v-row>
        <v-row no-gutters>
          <v-slide-y-transition>
            <v-col v-show="showContents" cols="12">
              <slot />
            </v-col>
          </v-slide-y-transition>
        </v-row>
      </v-container>
    </v-main>
    <v-footer app color="accent">
      <span class="text-caption" style="opacity:.6"><h-privacy-policy /></span>
      <v-spacer />
      <h-version top />
      <h-by-revo class="ml-2" />
    </v-footer>
  </v-app>
</template>

<script>
  import LoadsLocale from '@/Mixins/LoadsLocale'
  import HLocale from '@/Components/Locale'
  import HLogo from '@/Components/Logo/Brand'
  import HByRevo from '@/Components/Logo/ByRevo'
  import HCookieWarn from '@/Components/Legal/CookieWarn'
  import HPrivacyPolicy from '@/Components/Legal/PrivacyPolicy'
  import HVersion from '@/Components/Version'

  export default {
    mixins: [
      LoadsLocale,
    ],

    components: {
      HLocale,
      HLogo,
      HByRevo,
      HCookieWarn,
      HPrivacyPolicy,
      HVersion,
    },

    data: () => ({
      showLogo: false,
      showContents: false,
    }),

    created () {
      this.$vuetify.theme.dark = true
    },

    mounted () {
      setTimeout(() => this.showLogo = true, 50)
      setTimeout(() => this.showContents = true, 300)
    },
  }
</script>

<style lang="scss">
  html body {
    cursor: default;
  }
</style>
